import { getBackendUrlPrefixes } from "@/lib/apiBaseUrl";
import { generateFrontendJwtPerRequest } from "./jwtClient";

function getBackendBases(): string[] {
  return getBackendUrlPrefixes();
}

function resolveFetchUrl(input: RequestInfo | URL): string {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.toString();
  if (input instanceof Request) return input.url;
  return "";
}

function shouldAttachAuth(url: string, bases: string[]): boolean {
  return bases.some((base) => url.startsWith(base));
}

export function installBackendAuthFetchPatch(): void {
  if (typeof window === "undefined") return;
  if ((window as any).__optimusBackendFetchPatched) return;

  const originalFetch = window.fetch.bind(window);
  const backendBases = getBackendBases();

  (window as any).__optimusBackendFetchPatched = true;
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = resolveFetchUrl(input);

    if (!url || !shouldAttachAuth(url, backendBases)) {
      return originalFetch(input, init);
    }

    const headers = new Headers(init?.headers || {});
    // apiClient already attaches Authorization; avoid a second HMAC sign per request.
    if (!headers.has("Authorization")) {
      const token = await generateFrontendJwtPerRequest();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    }

    if (input instanceof Request) {
      return originalFetch(
        new Request(input, {
          ...init,
          headers,
        })
      );
    }

    return originalFetch(input, {
      ...init,
      headers,
    });
  };
}
